<!-- 采购订单数据操作 -->
<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="93px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                    <el-row v-if="dataActionBox.actionType != 2">

                      <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField"
                        :rules="formOneValue.isRequired == 1? [{ required: true, trigger: ['blur', 'change'] }]: []">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                        <!-- 日期 -->
                        <df-date v-if="formOneValue.entityField == 'psomBuydate'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]" :isShowLong="false"
                          :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.drtOrderDetail.length > 0 && formOneValue.isUpdate == 0)">
                        </df-date>
                        <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey)"
                          :isdisabled="formOneValue.isChange == 0 || (sendDataInfo.drtOrderDetail.length > 0 && formOneValue.isUpdate == 0)">
                        </df-date>
                        <!-- 检索方案 -->
                        <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                          :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
                          :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                          <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                            @keyup.enter.native="openSearch(formOneValue.searchId,formOneKey,formOneValue.entityField,formOneValue.setField)"
                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 || (sendDataInfo.drtOrderDetail.length > 0 && formOneValue.isUpdate == 0 && isTiQu)">
                            <el-button @click="openSearch(formOneValue.searchId,formOneKey,formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"
                              :disabled="formOneValue.isChange == 0 || (sendDataInfo.drtOrderDetail.length > 0 && formOneValue.isUpdate == 0 && isTiQu) || dataActionBox.actionType == 2">
                            </el-button>
                          </el-input>
                        </el-tooltip>
                        <!-- formatter下拉选   :automatic-dropdown="true"-->
                        <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                          :disabled="formOneValue.isChange == 0 || (sendDataInfo.drtOrderDetail.length > 0 && formOneValue.isUpdate == 0)" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                          </el-option>
                        </el-select>
                        <!-- 账期 -->
                        <el-input @keyup.enter.native="nextFocus(formOneKey)" type="number" v-else-if="formOneValue.entityField == 'credit'"
                          :disabled="formOneValue.isChange == 0 || (sendDataInfo.drtOrderDetail.length > 0 && formOneValue.isUpdate == 0)" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                        <!-- string类型 -->
                        <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else :disabled="formOneValue.isChange == 0 || (sendDataInfo.drtOrderDetail.length > 0 && formOneValue.isUpdate == 0)"
                          v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType == 2">
                      <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                        <span v-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{ sendDataInfo[formOneValue.entityField] }}</a>
                        </span>
                        <span v-else-if="formOneValue.fieldType == 'date'">
                          <span v-if="sendDataInfo[formOneValue.entityField]">
                            {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                          </span>
                        </span>
                        <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{sendDataInfo[formOneValue.entityField] == 1 ? "是" : "否"}}</span>
                        <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                  <!-- 明细信息 -->
                  <div>
                    <el-form :inline="true" size="mini">
                      <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                        <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                          新增</el-button>
                        <el-button type="primary" size="mini" @click="deleteDetails()">删除
                        </el-button>
                        <el-button type="primary" size="mini" @click="copyDetails()">复制
                        </el-button>
                        <el-link :underline="false" type="danger" style="margin-left: 10px">
                          (Alt+F1：新增明细</el-link>
                        <el-link :underline="false" type="danger" style="margin-left: 10px">
                          Alt+F2：删除明细)</el-link>
                      </div>
                      <el-table size="mini" class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.drtOrderDetail" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                        @selection-change="handleSelectionChange" border style="width: 100%" :height="mxHeight">
                        <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                          <template slot-scope="scope">
                            <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                            </el-radio>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" v-for="(formOneValue, formOneKey) in mxForm.jurconfigform"
                          :key="formOneKey" v-if="formOneValue.isShow == 1">
                          <template slot-scope="scope">
                            <el-input v-if="formOneValue.fieldType == 'search' &&dataActionBox.actionType != 2&& formOneValue.isChange == 1" clearable v-model="sendDataInfo.drtOrderDetail[scope.$index][formOneValue.entityField]"
                              :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 && formOneValue.isChange == 1">
                              <el-button @click="openSearch(formOneValue.searchId,scope.$index,formOneValue.entityField,formOneValue.setField,formOneValue.focusField)" slot="append" icon="el-icon-search"
                                :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                              </el-button>
                            </el-input>
                            <!-- 数量 -->
                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" @input="calculatePrice(5, scope.$index)" :ref="formOneValue.entityField"
                              v-else-if="formOneValue.entityField == 'drtPacknum' &&dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number" v-model="sendDataInfo.drtOrderDetail[scope.$index].drtPacknum">
                            </el-input>

                            <!-- 单价 -->
                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(1, scope.$index)" :ref="formOneValue.entityField"
                              v-else-if="formOneValue.entityField == 'price' &&dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                              v-model="sendDataInfo.drtOrderDetail[scope.$index][formOneValue.entityField]">
                            </el-input>

                            <!-- 含税价 -->
                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" @input="calculatePrice(2, scope.$index)" :ref="formOneValue.entityField"
                              v-else-if="formOneValue.entityField == 'psprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                              v-model="sendDataInfo.drtOrderDetail[scope.$index][formOneValue.entityField]">
                            </el-input>

                            <!-- 金额 -->
                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(3, scope.$index)" :ref="formOneValue.entityField"
                              v-else-if="formOneValue.entityField == 'money' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                              v-model="sendDataInfo.drtOrderDetail[scope.$index][formOneValue.entityField]">
                            </el-input>

                            <!-- 含税金额 -->
                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(4, scope.$index)" :ref="formOneValue.entityField"
                              v-else-if="formOneValue.entityField == 'psmoney' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                              v-model="sendDataInfo.drtOrderDetail[scope.$index][formOneValue.entityField]">
                            </el-input>
                            <span v-else-if="formOneValue.isRift == 1">
                              <a @click="toDetail(sendDataInfo.drtOrderDetail[scope.$index][formOneValue.riftField])">
                                {{sendDataInfo.drtOrderDetail[scope.$index][formOneValue.entityField]}}
                              </a>
                            </span>
                            <span v-else>{{sendDataInfo.drtOrderDetail[scope.$index][formOneValue.entityField]}}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form>
                  </div>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
        <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>>
      </div>
    </div>
    <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
      <el-table :data="dialogList" border style="width: 100%">
        <el-table-column prop="level" label="类型" width="50">
          <template slot-scope="{row}">
            <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
              {{ row.level == 0 ? "拦截" : '预警' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="data" label="内容" min-width="180">
        </el-table-column>
        <el-table-column prop="validity" label="有效期" min-width="100">
          <template slot-scope="{row}">
            {{ $common.getLocalTime(row.validity) }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
    <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
      <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
    </el-dialog>
    <historicalOrders ref="HistoricalOrders" />
    <component :is="currentComponent" :ref="currentComponent"></component>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
export default {
  name: "zdlbListAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    ExtractionScheme,
  },
  data() {
    //这里存放数据
    return {
      currentComponent: "",
      showDialog: false,
      showDialog1: false,
      flags: false,
      flag: -1,
      blurData: "",
      dialogList: [],
      mxHeight: 0,
      guaranteeBeginDay: "",
      detailRules: false, //规则
      selectDataTable: false,
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      detaislDataInfo: {},
      selectedDetailsIndex: 0,
      value1: "",
      sendDataInfo: {
        smId: ""
      },
      showTabs: "",
      formDataList: [],
      dictionariesData: {},
      userOneList: [],
      goodsList: [],
      storageRoomList: [],
      salesmanList: [],
      editDateilsIndex: "",
      exId: "",
      seId: "",
      ceshi: "",
      dialogTitle: "",
      seWidth: "",
      exTitle: "",
      seTitle: "",
      seWidth: "",
      exWidth: "",
      ppId: "orderId",
      DialogVisible: false,
      DialogExtract: false,
      newFormDataList: [],
      seType: "",
      smId: "",
      parentSearchData: {
        smId: "",
        orderType: 0, //	订单类型0.药品1.器械
      },
      isLoaded: false,
      orderId: "",
      printsouce: "",
      seIndex: 0, //选中索引
      isBuyer: 0,
      tabForm: [], // tab循环的主表单
      sField: "", // 赋值字段
      fField: "", //焦点字段
      nosField: "", // 不可赋值字段
      mxForm: [],
      footForm: [],
      selectedRow: [],
      isTiQu: true
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "sendDataInfo.drtOrderDetail": {
      handler: function (newValue, oldValue) {
        console.log(newValue, "456456564546564456645645645654645645645645")
        this.sendDataInfo.totalMoney = 0;
        this.sendDataInfo.totalNumber = 0;
        this.sendDataInfo.totalCount = 0;
        newValue.forEach((item, keys) => {
          for (let key in item) {
            if (item[key] == null || item[key] == 'null') {
              this.sendDataInfo.drtOrderDetail[keys][key] = ''
            }
          }
          let a = item.drtPacknum;
          if (item.drtPacknum == "") {
            item.drtPacknum = 0;
          } else if (a && a.length > 1 && a.substring(0, 1) == "0" && a.substring(1, 2) != ".") {
            item.drtPacknum = a.substring(1, a.length);
          }
          let b = item.psprice;
          if (item.psprice == "") {
            item.psprice = 0;
          } else if (b.length > 1 && b.substring(0, 1) == "0" && b.substring(1, 2) != ".") {
            item.psprice = b.substring(1, b.length);
          }
          if (item.drtPacknum < 0) {
            this.sendDataInfo["drtOrderDetail"][keys].drtPacknum = 0;
            return false;
          }
          if (item.price < 0) {
            this.sendDataInfo["drtOrderDetail"][keys].price = 0;
            return false;
          }
          if (item.money < 0) {
            this.sendDataInfo["drtOrderDetail"][keys].money = 0;
            return false;
          }
          if (item.psprice < 0) {
            this.sendDataInfo["drtOrderDetail"][keys].psprice = 0;
            return false;
          }
          if (item.psmoney < 0) {
            this.sendDataInfo["drtOrderDetail"][keys].psmoney = 0;
            return false;
          }
          this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
            3,
            NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
          );
          this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
            1,
            NP.plus(this.sendDataInfo.totalNumber, item.drtPacknum)
          );
        });
        this.sendDataInfo.totalCount = newValue.length;

      },
      deep: true,
    },
    "sendDataInfo.smName": {
      handler: function (newValue, oldValue) {
        if (newValue == '') {
          this.sendDataInfo.smId = ''
          this.sendDataInfo.salesName = "";
          this.sendDataInfo.salesId = "";
          this.parentSearchData.smId = ''
        }
      },
      deep: true,
    },
    "sendDataInfo.isPay": {
      handler: function (newValue, oldValue) {
        if (newValue == 0) {
          this.sendDataInfo.sbiName = ''
          this.sendDataInfo.sbiId = ''
          this.sendDataInfo.sbiNumber = ''
          this.tabForm[0].jurconfigform.forEach((item) => {
            if (item.entityField == 'sbiName' || item.entityField == 'sbiNumber') {
              item.isShow = 0
            }
          })
        } else {
          this.tabForm[0].jurconfigform.forEach((item) => {
            if (item.entityField == 'sbiName' || item.entityField == 'sbiNumber') {
              item.isShow = 1
            }
          })
        }
        this.$forceUpdate()
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    async blur(focusField, index, ownField, title) {
      setTimeout(async () => {//失去焦点事件和点击事件冲突addDetail
        if (title == 'blur') {
          this.blurData = title
        } else {
          this.blurData = ''
        }
        if (this.flags) {
          this.flags = false
          return
        }
        this.fField = focusField
        this.seIndex = index
        this.seType = ownField
        let params = {
          "formId": this.formDataList[1].jciId,
          "num": '',
          "psprice": ''
        }
        if (ownField == 'drtPacknum') {
          params.num = this.sendDataInfo.drtOrderDetail[index][ownField]
        } else if (ownField == 'psprice') {
          params.psprice = this.sendDataInfo.drtOrderDetail[index][ownField]
        }
        if (ownField) {
          await this.$http.interceptPuNumPsPrice(params).then(res => {
            this.flag = -1
            if (res.result != null && res.result.length > 0) {
              this.dialogList = res.result
              this.flag = this.dialogList.findIndex(item => item.level == 0)
            } else {
              console.log(this.sendDataInfo.drtOrderDetail[index][ownField]);
              if (this.sendDataInfo.drtOrderDetail[index][ownField] != 0) {
                this.tableNextFocus(this.fField, this.seIndex);
              }
            }
            if (this.flag == 0) this.showDialog1 = true
            if (this.flag != -1) {
              this.$nextTick(() => {
                // document.getElementById("qrBtn")?.focus();
                if (title != 'blur') {
                  this.flags = true
                }
                this.sendDataInfo.drtOrderDetail[index][ownField] = 0
                this.$refs[ownField][index].blur()
              })
            }
          })

        }
      }, 150)
    },
    intercept() {
      this.showDialog1 = false
      if (this.flag == -1) {
        this.tableNextFocus(this.fField, this.seIndex);
      } else {
        this.$nextTick(() => {
          this.$refs[this.seType][this.seIndex].focus()
        })
      }
    },
    Historical(url, title) {
      this.currentComponent = url
      var historicalOrder = {
        smName: "",
        smId: "",
        bgmName: "",
        bgmId: "",
      }
      if (this.currentComponent == 'historicalOrders') {
        historicalOrder.smName = this.sendDataInfo['smName']
        historicalOrder.smId = this.sendDataInfo['smId']
      }
      if (this.sendDataInfo['drtOrderDetail'].length > 0) {
        historicalOrder.bgmId = this.sendDataInfo['drtOrderDetail'][this.selectedDetailsIndex].bgmId
        historicalOrder.bgmName = this.sendDataInfo['drtOrderDetail'][this.selectedDetailsIndex].bgmName
      }
      this.$nextTick(() => {
        this.$refs[this.currentComponent].openBox(historicalOrder, title)
      })
    },
    //触发提取
    openExtSearch(id) {
      if (id == '629899519725569') {
        this.ppId = 'orderId'
      } else if (id == '949599709200712') {
        this.ppId = 'conmId'
      } else if (id == '538560780537856') {
        this.ppId = 'pmId'
      }
      this.exId = id;
      this.DialogExtract = true;
    },
    //提取返回
    async getDataByChen(val) {
      console.log(val)

      if (val != "" || val != undefined) {
        this.$http
          .checkVendorLicense({
            //校验购进单位
            formId: this.formDataList[0].jciId, //表单ID
            unitId: val.smId || '', //单位ID
          })
          .then((res) => {

            if (res && res.status == 200) {
              let flag = -1
              if (res.result != null && res.result.length > 0) {
                this.dialogList = res.result
                flag = this.dialogList.findIndex(item => item.level == 0)
                this.showDialog = true
              }

              if (flag == -1) {
                for (let key in val) {
                  if (key == "arrlistbychen") {
                    this.sendDataInfo.drtOrderDetail = val.arrlistbychen;
                  } else {
                    console.log(key);

                    this.sendDataInfo[key] = val[key];
                    this.sendDataInfo.totalMoney = 0
                    this.sendDataInfo.totalNumber = 0
                    this.sendDataInfo.totalCount = 0
                  }
                }
                this.sendDataInfo.drtOrderDetail.forEach((item, index) => {
                  this.sendDataInfo.totalMoney += item.rrdPsmoney
                  this.sendDataInfo.totalNumber += item.oldNum
                  this.calculatePrice(5, index)
                })
                this.parentSearchData.smId = val.smId
                this.sendDataInfo.totalCount = this.sendDataInfo.drtOrderDetail.length
                this.isTiQu = false
                // 
                // let responseData = await this.$http.getOrderId({ ids: [val.psaiId] });
                // this.sendDataInfo.pisOrderauxinfVo = responseData.result;
                this.DialogExtract = false;

                this.$nextTick(() => {
                  this.selectedDetailsIndex = 0
                  let refsElTable = this.$refs.mxTableRef
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(this.sendDataInfo.drtOrderDetail[this
                    .selectedDetailsIndex]);
                  this.nextFocus(0)
                })
              } else {
                this.showDialog = true
              }
            }
          })

      }
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 查看证照
    lookLicence() {
      if (this.sendDataInfo.smId == "") {
        return this.$message({
          message: "请先选择供货单位",
          type: "warning",
        });
      }
      this.$parent.$parent.toDetail(this.sendDataInfo.smId);
    },
    closeChild() {
      addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    // 保存已选择行
    handleSelectionChange(rows) {
      this.selectedRow = rows; // 保存已选择行
    },
    // 明细表格点击选中
    clickEvent(row, column, event, params) {
      let refsElTable = this.$refs.mxTableRef; // 获取表格对象
      let findRow = {};
      this.selectedDetailsIndex = row.rowIndex;
      findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.selectedRow.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
    },
    // 表格方法
    rowClassName({
      row,
      rowIndex
    }) {
      let rowName = "",
        findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },
    // 选中行底色逻辑
    rowStyle({
      row,
      rowIndex
    }) {
      Object.defineProperty(row, "rowIndex", {
        // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false,
      });
      let rowBackground = {}
      if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
      return rowBackground
    },
    // 主表单select框切换enter切换焦点事件方法
    selectChange(e) {
      if (e == false) {
        for (let index = 0; index < this.inputel.length; index++) {
          if (this.inputel[index] == document.activeElement) {
            this.nextFocus(index);
            break;
          }
        }
      }
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= this.inputel.length - 1) {
        if (this.sendDataInfo.drtOrderDetail.length > 0) { }
        this.addDetail("sendDataInfo");
        return;
      }
      var aindex = index + 1;
      if (this.inputel[aindex].value != "" || this.inputel[aindex].disabled) {
        this.nextFocus(aindex);
        return;
      }
      this.inputel[aindex].focus();
    },

    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == "") {
          this.inputel[index].focus();
          break;
        }
      }
    },

    // 表格切换焦点方法
    tableNextFocus(field, index) {
      if (field == "keydown") {
        this.addDetail("sendDataInfo");
        if (this.sendDataInfo.drtOrderDetail[index + 1] != undefined) {
          this.$refs["bgmName"][index + 1].focus();
          return;
        }
        // if(this.blurData != 'blur'){
        //     this.addDetail("sendDataInfo");
        // }

        return;
      }
      this.$refs[field][index].focus();
    },
    showPrintPlan() {
      // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        console.log("选中的数据", this.actionData);
        this.$refs.printPlan.openDia(
          this.actionData.orderId,
          this.actionData.printSouce,
          this.actionData.printJurId
        );
      } else {
        return;
      }
    },
    toDetail(orderId) {
      // console.log(this.$parent.$parent.$parent);
      this.$parent.$parent.$parent.toDetail(orderId);
    },
    //换行提示
    lineMessageBox(data) {
      let txtArr = data.message.split("<br/>");
      let newArr = [];
      const h = this.$createElement;
      for (const i in txtArr) {
        newArr.push(h("p", null, txtArr[i]));
      }
      this.$alert(h("div", null, newArr), "提示", {
        confirmButtonText: "确定",
        callback: (action) => { },
      });
    },
    // 赋值字段
    paramValue(val) {
      console.log(val, "123313152312321312312312")
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = val[item];
      });
      console.log(this.sendDataInfo, "1233131523123213123//////12312")
      this.$nextTick(() => {
        this.nextFocus(this.seIndex);
      });
    },
    // 表格赋值字段
    mxParamValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo.drtOrderDetail[this.seIndex][item] = val[item];
      });
      this.sendDataInfo.drtOrderDetail.splice(1, 0)
      // this.$nextTick(() => {
      // 	this.tableNextFocus(this.fField, this.seIndex);
      // });
    },
    // 清除赋值字段数据
    clearValue() {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = "";
      });
    },
    //提取返回
    changeInputModel(val) {
      console.log(this.seType,'this.seType');
      
      console.log("返回", val, this.seType);
      if (val != "" && val != undefined) {
        this.DialogVisible = false;
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
        if (val.depId) {
          this.sendDataInfo.depId = val.depId;
          this.sendDataInfo.depName = val.depName;
        }
        var type = ""
        if (this.seType == "bgmName") {
          var bgiTypeArr = [];
          var bgmIds = []
          var repeatBgmId=[]
          this.sendDataInfo.drtOrderDetail.forEach((v) => {
            if (v.bgmName != ''&& v.bgmId != "") {
              bgiTypeArr.push(v.bgiType);
              repeatBgmId.push(v.bgmId);
            }
          });
          if (val.length > 0) {
            val.forEach(item => {
              bgmIds.push(item.bgmId)
              bgiTypeArr.push(item.bgiType)
              repeatBgmId.push(item.bgmId);
            })
          } else {
            bgiTypeArr.push(val.bgiType)
            bgmIds = [val.bgmId]
            repeatBgmId.push(val.bgmId);
          }
          this.$http
            .checkPurchasingScope({
              //校验明细商品
              formId: this.mxForm.jciId, //表单ID
              unitId: this.sendDataInfo.smId, //单位ID
              bgmId: bgmIds, //商品id
              // repeatBgmId: repeatBgmId,//重复商品id
              ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId, //组织ID
              salesId: this.sendDataInfo.pusalesId, //对方业务员ID
              bgiTypes: bgiTypeArr, //药品类型
            })
            .then((res) => {
              if (res && res.status == 200) {
                this.flag = -1
                this.dialogList = res.result
                if (this.dialogList != null && this.dialogList.length > 0) {
                  this.flag = this.dialogList.findIndex(item => item.level == 0)
                  this.showDialog = true

                }
                if (this.flag == -1) {
                  if (val.length > 0) {
                    this.bgmSelect(val)
                    return
                  }
                  for (let key in val) {
                    this.sendDataInfo.drtOrderDetail[this.seIndex][key] =
                      val[key];
                  }
                  this.sendDataInfo.drtOrderDetail[this.seIndex].psodPsdvolume =
                    val.rjXl;
                  this.sendDataInfo.drtOrderDetail[this.seIndex].psodPsnvolume =
                    val.stockNum;
                  this.sendDataInfo.drtOrderDetail[
                    this.seIndex
                  ].psodPsupperlimit = val.limdHighnum;
                  this.sendDataInfo.drtOrderDetail[
                    this.seIndex
                  ].psodPslowerlimit = val.limdLownum;
                  if (!this.dialogList.length) {
                    this.tableNextFocus(this.fField, this.seIndex);
                  }
                } else {
                  this.showDialog = true

                }
                return true

              } else {
                this.lineMessageBox(res);
                this.$set(
                  this.sendDataInfo.drtOrderDetail,
                  this.seIndex,
                  JSON.parse(JSON.stringify(this.detaislDataInfo))
                );
                return false;
              }
            })
            .catch((rej) => {
              this.lineMessageBox(rej);
              for (let key in this.sendDataInfo.drtOrderDetail[this.seIndex]) {
                this.sendDataInfo.drtOrderDetail[this.seIndex][key] = "";
              }
            });
        } else if (this.seType == "smName") {
          this.$http
            .checkVendorLicense({
              //校验购进单位
              formId: this.formDataList[0].jciId, //表单ID
              unitId: val.smId, //单位ID
            })
            .then((res) => {

              if (res && res.status == 200) {
                let flag = -1
                if (res.result != null && res.result.length > 0) {
                  this.dialogList = res.result
                  flag = this.dialogList.findIndex(item => item.level == 0)
                  this.showDialog = true

                }

                if (flag == -1) {
                  this.parentSearchData.smId = val.smId;
                  this.paramValue(val);
                  // type = "salesName"
                } else {
                  this.showDialog = true
                }
              } else {
                this.lineMessageBox(res);

                this.parentSearchData.smId = "";
                this.clearValue();
                return false;
              }
            })
            .catch((rej) => {
              this.lineMessageBox(rej);

              this.parentSearchData.smId = "";
              this.clearValue();
            });
          if (val.pusalesId) {
            this.$http
              .checkSalesLicense({
                //校验供应商业务员
                formId: this.formDataList[0].jciId, //表单ID
                salesId: val.pusalesId, //业务员ID
              })
              .then((res) => {
                if (res && res.status == 200) {
                  let flag = -1
                  if (res.result != null && res.result.length > 0) {
                    this.dialogList = res.result
                    flag = this.dialogList.findIndex(item => item.level == 0)
                    this.showDialog = true
                  }
                  if (flag == -1) {
                    this.paramValue(val);
                  }
                } else {
                  this.clearValue();
                  this.lineMessageBox(res);

                  return false;
                }
              })
              .catch((rej) => {
                this.clearValue();
                this.lineMessageBox(rej);

              });
          }
          if (val.susalesId) {
            this.$http
              .checkSalesLicense({
                //校验供应商业务员
                formId: this.formDataList[0].jciId, //表单ID
                salesId: val.susalesId, //业务员ID
              })
              .then((res) => {
                if (res && res.status == 200) {
                  let flag = -1
                  if (res.result != null && res.result.length > 0) {
                    this.dialogList = res.result
                    flag = this.dialogList.findIndex(item => item.level == 0)
                    this.showDialog = true
                  }
                  if (flag == -1) {
                    this.paramValue(val);
                  }
                } else {
                  this.clearValue();
                  this.lineMessageBox(res);

                  return false;
                }
              })
              .catch((rej) => {
                this.clearValue();
                this.lineMessageBox(rej);

              });
          }

        } else if (this.seType == "salesName") {
          this.$http
            .checkSalesLicense({
              //校验供应商业务员
              formId: this.formDataList[0].jciId, //表单ID
              salesId: val.salesId, //业务员ID
            })
            .then((res) => {
              if (res && res.status == 200) {
                let flag = -1
                if (res.result != null && res.result.length > 0) {
                  this.dialogList = res.result
                  flag = this.dialogList.findIndex(item => item.level == 0)
                  this.showDialog = true
                }
                if (flag == -1) {
                  this.paramValue(val);
                }
              } else {
                this.clearValue();
                this.lineMessageBox(res);

                return false;
              }
            })
            .catch((rej) => {
              this.clearValue();
              this.lineMessageBox(rej);

            });
        } else if (this.seType == "susalesName") {
          this.$http
            .checkSalesSale({
              //校验供应商业务员
              formId: this.formDataList[0].jciId, //表单ID
              salesId: val.susalesId, //业务员ID
            })
            .then((res) => {
              if (res && res.status == 200) {
                let flag = -1
                if (res.result != null && res.result.length > 0) {
                  this.dialogList = res.result
                  flag = this.dialogList.findIndex(item => item.level == 0)
                  this.showDialog = true
                }
                if (flag == -1) {
                  this.paramValue(val);
                }
              } else {
                this.clearValue();
                this.lineMessageBox(res);

                return false;
              }
            })
            .catch((rej) => {
              this.clearValue();
              this.lineMessageBox(rej);

            });
        }
        else if (this.seType == "pusalesName") {
          this.$http
            .checkSalesLicense({
              //校验供应商业务员
              formId: this.formDataList[0].jciId, //表单ID
              salesId: val.pusalesId, //业务员ID
            })
            .then((res) => {
              if (res && res.status == 200) {
                let flag = -1
                if (res.result != null && res.result.length > 0) {
                  this.dialogList = res.result
                  flag = this.dialogList.findIndex(item => item.level == 0)
                  this.showDialog = true
                }
                if (flag == -1) {
                  this.paramValue(val);
                }
              } else {
                this.clearValue();
                this.lineMessageBox(res);

                return false;
              }
            })
            .catch((rej) => {
              this.clearValue();
              this.lineMessageBox(rej);

            });
        }

        else if (this.seType == "stName") {
          this.mxParamValue(val);
        } else if (this.seType == "coName") {
          this.paramValue(val);
          this.parentSearchData.coId = val.coId;
        } else {
          this.paramValue(val);
        }
        if (type == 'salesName' && val.salesId) {
          this.$http
            .checkSalesLicense({
              //校验供应商业务员
              formId: this.formDataList[0].jciId, //表单ID
              salesId: val.salesId, //业务员ID
            })
            .then((res) => {
              if (res && res.status == 200) {
                let flag = -1
                if (res.result != null && res.result.length > 0) {
                  this.dialogList = res.result
                  flag = this.dialogList.findIndex(item => item.level == 0)
                  this.showDialog = true
                }
                if (flag == -1) {
                  this.paramValue(val);
                }
              } else {
                this.clearValue();
                this.lineMessageBox(res);

                return false;
              }
            })
            .catch((rej) => {
              this.clearValue();
              this.lineMessageBox(rej);

            });
        }
      }
      // this.sendDataInfo.drtOrderDetail[this.seIndex].bgmName = val.bgmName

    },
    bgmSelect(val) {
      if (this.sendDataInfo.drtOrderDetail && this.sendDataInfo.drtOrderDetail.length > 0) {
        var mx = JSON.parse(JSON.stringify(val))
        this.sendDataInfo.drtOrderDetail.forEach((item, index) => {
          if (item.bgmId == '' || item.bgmName == '') {
            this.sendDataInfo.drtOrderDetail.splice(index, 1)
          }
        })
        mx.forEach((item) => {
          this.sendDataInfo.drtOrderDetail.push({})
          for (const key in this.detaislDataInfo) {
            this.$set(this.sendDataInfo.drtOrderDetail[this.sendDataInfo.drtOrderDetail.length - 1], key, item[key] != undefined && item[key] != null ? item[key] : '')
          }
        })
      } else {
        this.sendDataInfo.drtOrderDetail = []
        val.forEach((item, index) => {
          this.sendDataInfo.drtOrderDetail.push({})
          for (const key in this.detaislDataInfo) {
            this.$set(this.sendDataInfo.drtOrderDetail[index], key, item[key] != undefined && item[key] != null ? item[key] : '')
          }
        })
      }
      this.selectedDetailsIndex = this.sendDataInfo.drtOrderDetail.length - 1
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
    openSearch(sId, index, type, sField, fField, nosField) {
      setTimeout(() => {
        this.showDialog = false
      }, 16.7)
      if (type == "salesName" || type == "caiAddress" || type == "recName" || type == 'sbiName') {
        if (this.sendDataInfo.smId == "") {
          return this.$message({
            message: "请先选择单位",
            type: "warning",
          });
        }
      }
      if (type == "stName") {
        this.parentSearchData.stName =
          this.sendDataInfo.drtOrderDetail[this.selectedDetailsIndex].stName;
      }
      if (type == 'opmName') {
        this.parentSearchData.opmSalesperson = 1
      }
      this.DialogVisible = true;
      removeEventListener("keyup", this.keyUp);
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField;
      this.fField = fField;
      this.parentSearchData.stId = this.sendDataInfo.stId;
      this.parentSearchData.cmId = this.sendDataInfo.cmId;
      this.parentSearchData.coId = this.sendDataInfo.coId;
      console.log(this.parentSearchData)
      if (this.sendDataInfo.drtOrderDetail.length) {
        this.parentSearchData.bgmName =
          this.sendDataInfo.drtOrderDetail[this.seIndex].bgmName;
      }

      if (type == "bgmName") {
        if (this.parentSearchData.bgmName) {
          let fh = 0
          if (this.parentSearchData.bgmName.indexOf(',') != -1) {
            fh = ','
          } else if (this.parentSearchData.bgmName.indexOf('，') != -1) {
            fh = '，'
          }
          if (fh !== 0) {
            const str = this.parentSearchData.bgmName
            const list = str.split(fh)
            this.parentSearchData.bgmName = list[0] || ''
            this.parentSearchData.manufacturer = list[1] || ''
          } else {
            this.parentSearchData.manufacturer = ''
          }
        } else {
          this.parentSearchData.bgmName = ''
          this.parentSearchData.manufacturer = ''
        }
        return;
      }
      this.parentSearchData[type] = this.sendDataInfo[type];


    },
    tableRowClassName({
      row,
      rowIndex
    }) {
      row.index = rowIndex;
    },
    //新增明细
    addDetail(sendDataInfo) {
      var flag = false
      if (this.sendDataInfo.drtOrderDetail.length > 0) {
        this.sendDataInfo.drtOrderDetail.forEach(item => {
          if (item.bgmId == "") {
            flag = true
            return this.$message({
              message: "请不要重复新增空白行",
              type: "warning",
            });
          }
        })
      }
      if (flag) {
        return
      }
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.sendDataInfo.drtOrderDetail.push({})
          var index = this.sendDataInfo.drtOrderDetail.length - 1
          for (const key in this.detaislDataInfo) {
            this.$set(this.sendDataInfo.drtOrderDetail[index], key, this.detaislDataInfo[key])
          }
          this.$nextTick(() => {
            this.selectedDetailsIndex = Number(
              this.sendDataInfo.drtOrderDetail.length - 1
            );
            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.drtOrderDetail[this.selectedDetailsIndex]
            );
          });
        } else {
          return this.$message({
            message: "请完善必填信息",
            type: "warning",
          });
        }
      });
    },
    detailsAction(cate = 0) {
      if (cate == 0) {
        this.editDateilsIndex = "";
        return false;
      }

      var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo));
      if (dataInfo.drtPacknum <= 0) {
        this.$message({
          message: "请填写采购数量",
          type: "error",
        });
        return false;
      }
      if (this.editDateilsIndex !== "") {
        this.sendDataInfo.drtOrderDetail.splice(this.editDateilsIndex, 1);
      }
      this.sendDataInfo.drtOrderDetail.push(dataInfo);
      this.editDateilsIndex = "";
    },
    // 计算价格
    calculatePrice(cate, index) {
      var info = this.sendDataInfo.drtOrderDetail[index];
      if (info.drtPacknum <= 0) {
        this.$message({
          message: "请先填写采购数量",
          type: "error",
        });
        return false;
      }
      switch (cate) {
        case 1: // 单价计算
          // 计算含税价格 单价+单价*税率/100
          var thisPrice = NP.plus(
            info.price,
            NP.divide(NP.times(info.price, info.inRate), 100)
          );
          this.sendDataInfo.drtOrderDetail[index].psprice =
            this.$common.getDecimalInfo(2, thisPrice);
          // 计算金额 单价*数量
          this.sendDataInfo.drtOrderDetail[index].money =
            this.$common.getDecimalInfo(
              3,
              NP.times(info.price, info.drtPacknum)
            );
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.drtOrderDetail[index].psmoney =
            this.$common.getDecimalInfo(
              3,
              NP.times(thisPrice, info.drtPacknum)
            );
          //计算税额
          this.sendDataInfo.drtOrderDetail[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info
            .psmoney, info.money))
          break;
        case 2: // 含税价格计算
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.drtOrderDetail[index].psmoney = info.drtPacknum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.drtPacknum));
          // 计算金额 含税金额/(税率/100+1)
          var midmoney = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.drtOrderDetail[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)))
          // var midmoney = NP.divide(this.sendDataInfo.drtOrderDetail[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)).toFixed(10)
          this.sendDataInfo.drtOrderDetail[index].money = this.$common.getDecimalInfo(3, midmoney);
          // 计算单价 金额/数量
          this.sendDataInfo.drtOrderDetail[index].price = info.drtPacknum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.drtPacknum));
          //计算税额
          this.sendDataInfo.drtOrderDetail[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.drtOrderDetail[index].psmoney, this.sendDataInfo.drtOrderDetail[index].money));
          break;
        case 3: // 通过总金额计算
          // 计算单价  总金额 / 数量
          var thisPrice = NP.divide(info.money, info.drtPacknum);
          this.sendDataInfo.drtOrderDetail[index].price =
            this.$common.getDecimalInfo(2, thisPrice);
          // 计算含税价格 单价+单价*税率/100
          var thisPriceTwo = NP.plus(
            thisPrice,
            NP.divide(NP.times(thisPrice, info.inRate), 100)
          );
          this.sendDataInfo.drtOrderDetail[index].psprice =
            this.$common.getDecimalInfo(3, thisPriceTwo);

          // 计算整件数量
          this.sendDataInfo.drtOrderDetail[index].wholeNum = Math.floor(NP.divide(info.drtPacknum, Number(
            info.packingSpec)))

          //计算零散数量
          this.sendDataInfo.drtOrderDetail[index].scatNum = info.drtPacknum - info.wholeNum * Number(info
            .packingSpec)

          //计算零散数量
          // this.sendDataInfo.drtOrderDetail[index].scatNum = this.$common.getDecimalInfo(1, NP.minus(info.drtPacknum - NP.times(info.wholeNum, Number(info.packingSpec))))

          //计算税额
          this.sendDataInfo.drtOrderDetail[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info
            .psmoney, info.money))
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.drtOrderDetail[index].psmoney =
            this.$common.getDecimalInfo(
              3,
              NP.times(thisPriceTwo, info.drtPacknum)
            );
          break;
        case 4: // 通过含税金额计算
          // 计算含税价格  含税金额 / 数量
          this.sendDataInfo.drtOrderDetail[index].psprice = info.drtPacknum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(info.psmoney, info.drtPacknum));
          // 计算总金额 含税金额/(税率/100+1)
          var midmoney = this.$common.getDecimalInfo(3, NP.divide(info.psmoney, NP.plus(NP.divide(info.inRate, 100), 1)))
          // var midmoney = NP.divide(info.psmoney, NP.plus(NP.divide(info.inRate, 100), 1)).toFixed(10)
          this.sendDataInfo.drtOrderDetail[index].money = this.$common.getDecimalInfo(3, midmoney);
          // 计算单价 金额/数量
          this.sendDataInfo.drtOrderDetail[index].price = info.drtPacknum === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.drtPacknum));
          //计算税额
          this.sendDataInfo.drtOrderDetail[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, this.sendDataInfo.drtOrderDetail[index].money));
          break;
        default:
          // 通过数量计算
          //计算零散数量
          // this.sendDataInfo.drtOrderDetail[index].scatNum = info.drtPacknum - info.wholeNum * Number(info.packingSpec)
          // 计算含税金额 含税价格*数量
          var midmoney = info.drtPacknum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.drtPacknum));
          var midmoney = info.drtPacknum === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.drtPacknum));
          // var midmoney = info.drtPacknum === 0 ? 0 : NP.times(info.psprice, info.drtPacknum).toFixed(10);
          this.sendDataInfo.drtOrderDetail[index].psmoney = this.$common.getDecimalInfo(3, midmoney);
          // 计算总金额 含税金额/(税率/100+1)
          this.sendDataInfo.drtOrderDetail[index].money = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.drtOrderDetail[index].psmoney, NP.plus(NP.divide(info.inRate, 100), 1)));
          // 计算整件数量
          this.sendDataInfo.drtOrderDetail[index].wholeNum = Math.floor(NP.divide(info.drtPacknum, Number(info.packingSpec)));
          //计算零散数量
          this.sendDataInfo.drtOrderDetail[index].scatNum = NP.minus(info.drtPacknum, NP.times(this.sendDataInfo.drtOrderDetail[index].wholeNum, Number(info.packingSpec)));
          //计算税额
          this.sendDataInfo.drtOrderDetail[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(this.sendDataInfo.drtOrderDetail[index].psmoney, this.sendDataInfo.drtOrderDetail[index].money));

          // 计算件数 采数/包装单位
          if (parseFloat(info.packingSpec) <= 0 || info.packingSpec == "") {
            this.sendDataInfo.drtOrderDetail[index].pieceNum = 0;
          } else {
            this.sendDataInfo.drtOrderDetail[index].pieceNum =
              this.$common.getDecimalInfo(
                1,
                NP.divide(info.drtPacknum, info.packingSpec)
              );
          }

          break;
      }
    },
    initActionBox(sendDataInfo) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
      this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel", 0);
          // this.$parent.getDataList()
          this.init();
          this.$refs[sendDataInfo].resetFields();
        })
        .catch(() => { });
    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "pisOrderAuxinf") {
          for (let sonOne in this.sendDataInfo[key]) {
            this.sendDataInfo[key][sonOne] = "";
          }
        } else {
          this.sendDataInfo[key] = "";
        }
      }
      // this.sendDataInfo.psomBuydate = this.$moment().valueOf();

      this.sendDataInfo.drtOrderDetail = [];
      this.sendDataInfo.totalMoney = 0;
      this.sendDataInfo.totalNumber = 0;
      this.sendDataInfo.totalCount = 0;
      this.sendDataInfo.orderType = 0; //orderType	订单类型0.药品订单1.器械订单
    },

    changeFocus() {
      setTimeout(() => {
        var el = document.getElementById("mainInfo");
        var inel = el.getElementsByClassName("el-input__inner");
        for (let index = 0; index < inel.length; index++) {
          if (inel[index].value == "") {
            inel[index].focus();
            break;
          }
        }
      }, 500);
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById("mainInfo");
      if (el) this.inputel = el.getElementsByTagName("input");
    },
    openBox() {
      this.dataActionBox.actionType = this.actionData.cate;
      this.formDataList = this.actionData.formData;
      this.filterMainField();
      var oldData = this.actionData.oldData;
      this.showTabs = this.actionData.formData[0].jciName;
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
        this.parentSearchData.smId = "";
        this.initDefaultValue()
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }
        this.smId = dataInfo.smId;
        this.parentSearchData.smId = oldData.smId
        this.$nextTick(() => {
          this.selectedDetailsIndex = 0;
          setTimeout(() => {
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.drtOrderDetail[this.selectedDetailsIndex]
            );
          }, 16.7)
        });
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }
      }

      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.$refs['tree'].init(this.sendDataInfo.psomId)
            this.mxHeight = this.$common.getHeight()
          }
        }, 16.7)

      });
      this.changeFocus();
    },
    // 默认值
    initDefaultValue() {
      let arr = this.formDataList[0].jurconfigform
      arr.forEach(item => {
        if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
          this.sendDataInfo[item.entityField] = item.defaultValue
        }
      })
      this.sendDataInfo.isPay = Number(this.sendDataInfo.isPay)
      this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms)
      this.sendDataInfo.psomBuydate = this.$moment().valueOf();
      this.sendDataInfo.psaiDeptime = this.$moment().valueOf();
      this.sendDataInfo.psaiExptime = this.$moment().valueOf();
      this.sendDataInfo.drtDate = this.$moment().valueOf();
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = [];
      this.formDataList.forEach((item) => {
        if (item.jciType == 1) {
          mainFormList.push(item);
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item));
          this.mxForm.jurconfigform.forEach(item1 => {
            if (item1.fieldType == 'number') {
              this.$set(this.detaislDataInfo, item1.entityField, 0)
            } else if (item1.fieldType == 'search' && item1.setField) {
              var arr = item1.setField.split(',')
              arr.forEach(item2 => {
                this.$set(this.detaislDataInfo, item2, "")
              })
            } else {
              this.$set(this.detaislDataInfo, item1.entityField, "")
            }
          })
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
        }
      });
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key));
        this.tabForm[i].jurconfigform = [];
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1 || key.jurconfigform[index].entityField == 'sbiName' || key.jurconfigform[index].entityField == 'sbiNumber')
            this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
        }
      });
      var arr = [{ entityField: "drtOrderDetail" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {
        this.$set(this.sendDataInfo, key, obj[key])
      }
      this.$set(this.sendDataInfo, 'orderType', 0)//订单类型0.药品订单1.器械订单
    },
    //确认新增
    sendDataAction(formName1) {
      let flag = false;
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          this.sub();
        } else {
          this.$message({
            message: "请完善主表单必填信息",
            type: "error",
          });
          flag = true;
          return false;
        }
      });
    },
    async sub() {
      if (this.sendDataInfo.drtOrderDetail.length < 1) {
        this.$message({
          message: "请添加直调订单明细",
          type: "error",
        });
        return;
      } else {
        this.sendDataInfo.drtOrderDetail.forEach((item, index) => {
          if (item.bgmId == "") {
            this.sendDataInfo.drtOrderDetail.splice(index, 1);
          }
        });
      }
      this.sendDataInfo.totalCount=this.sendDataInfo.drtOrderDetail.length

      if (this.dataActionBox.actionType == 0) {//新增
        var responseData = await this.$http.directOrderAdd(this.sendDataInfo);
      } else {
        var responseData = await this.$http.directOrderOrderUpdate(this.sendDataInfo);
      }
      if (responseData.status == 200) {
        this.init();
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel", 1);
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    deleteDetails() {
      if (this.sendDataInfo.drtOrderDetail.length < 1) {
        this.isTiQu = true
        return this.$message({
          message: "暂无可删除明细",
          type: "warning",
        });
        return false;
      }

      this.sendDataInfo.drtOrderDetail.splice(this.selectedDetailsIndex, 1);
      if (this.sendDataInfo.drtOrderDetail.length > 1) {
        this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
      } else {
        this.selectedDetailsIndex = 0;
      }
      this.tableNextFocus("bgmName", this.selectedDetailsIndex);
      let refsElTable = this.$refs.mxTableRef;
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(
        this.sendDataInfo.drtOrderDetail[this.selectedDetailsIndex]
      );
    },
    // 复制
    copyDetails() {
      if (this.sendDataInfo.drtOrderDetail.length < 1) {
        return this.$message({
          message: "暂无可复制明细",
          type: "warning",
        });
        return false;
      } else {
        this.sendDataInfo.drtOrderDetail.push(
          JSON.parse(
            JSON.stringify(
              this.sendDataInfo.drtOrderDetail[this.selectedDetailsIndex]
            )
          )
        );
      }
    },

    // 判断是不是采购员
    checkIsBuyer() {
      if (this.dataActionBox.actionType != 0) return;
      let info = JSON.parse(sessionStorage.getItem("userInfo"));
      if (info.opmSalesperson == 1) {
        this.sendDataInfo.depName = info.depName;
        this.sendDataInfo.depId = info.depId;
        this.sendDataInfo.opmName = info.opmName;
        this.sendDataInfo.opmId = info.opmId;
        this.tabForm[0].jurconfigform.forEach((item) => {
          if (
            item.entityField == "opmName" ||
            item.entityField == "depName"
          )
            item.isChange = 0;
        });
      }
    },
    // 监听键盘事件
    keyUp(e) {
      if (e.key == "F1") {
        // 右键新增明细
        e.preventDefault();
        this.addDetail("sendDataInfo");
        return;
      } else if (e.key == "F2") {
        e.preventDefault();
        this.deleteDetails();
      } else if (e.keyCode == 40) {
        // 下键
        // 表格为空，不执行下方
        if (this.sendDataInfo.drtOrderDetail.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 如果当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (
            this.selectedDetailsIndex ==
            this.sendDataInfo.drtOrderDetail.length - 1
          ) {
            // 如果选中的是最后一行了，那么下一行选中的是第一行
            this.selectedDetailsIndex = 0;
          } else {
            // 正常递增
            this.selectedDetailsIndex++;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.drtOrderDetail[this.selectedDetailsIndex],
              false
            );
            return;
          }
          this.tableNextFocus("bgmName", this.selectedDetailsIndex);
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.drtOrderDetail[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      } else if (e.keyCode == 38) {
        // 上键
        if (this.sendDataInfo.drtOrderDetail.length == 0) return;
        let refsElTable = this.$refs.mxTableRef;
        this.$nextTick(() => {
          if (this.selectedRow.length == 0) {
            // 当前没有选中行，则直接选中第一个
            this.selectedDetailsIndex = 0;
          } else if (this.selectedDetailsIndex == 0) {
            // 如果选中的是第一行了，那么下一行选中的是最后一行
            this.selectedDetailsIndex =
              this.sendDataInfo.drtOrderDetail.length - 1;
          } else {
            // 正常递减
            this.selectedDetailsIndex--;
          }
          if (!refsElTable) return;
          let findRow = this.selectedRow.find(
            (c) => c.rowIndex == this.selectedDetailsIndex
          ); //找出当前选中行
          //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
          if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(
              this.sendDataInfo.drtOrderDetail[this.selectedDetailsIndex],
              false
            );
            return;
          }
          this.tableNextFocus("bgmName", this.selectedDetailsIndex);
          refsElTable.clearSelection();
          refsElTable.toggleRowSelection(
            this.sendDataInfo.drtOrderDetail[this.selectedDetailsIndex]
          ); // 把现在当前行勾选
        });
      }
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox();
      this.checkIsBuyer();
      this.isLoaded = true;
    });

        this.$dbCache.Record_Get(4).then((res) => {//选择明细后不允许更换单位
      //明细拦截
      let obj = res
      if (obj.isEnable == 1) this.detailRules = true;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    addEventListener("keyup", this.keyUp); //创建监听键盘事件
  },
  beforeDestroy() {
    removeEventListener("keyup", this.keyUp);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    setTimeout(() => {
      this.getMainInput();
    }, 16.7)
  }, //生命周期 - 更新之后
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.v-modal {
  position: static !important;
  width: 100%;
  height: 100%;
  background: transparent;
}

::v-deep .el-alert__content {
  width: 100%;
}
</style>